import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import Header from "../../Pages/Dashboard/Header";
import FooterStrict from "../../Pages/Dashboard/FooterStrict";
import Edit from "../../Assets/images/edit_pencil.png";
import DeleteIcon from "../../Assets/images/delete-white.jpg";


const CreateEditCategory = () => {
  const data = [
    {
      upc: "123456789012",
      pro_name: "Test Product 1",
      item_code: "P001",
      category: "Beverages"
    },
    {
      upc: "987654321098",
      pro_name: "Cross Sell Item",
      item_code: "P002",
      category: "Snacks"
    },
    {
      upc: "555666777888",
      pro_name: "Discounted Product",
      item_code: "P003",
      category: "Household"
    }
  ];
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [isPopupdel, setPopupdelVisible] = useState(false);


  const openModal = () => setIsModalVisible(true);
  const closeModal = () => setIsModalVisible(false);

  const togglePopup = () => setPopupVisible(!isPopupVisible);
  const toggledelPopup = () => setPopupdelVisible(!isPopupdel);

  const DelIcon = ({ width = 20, height = 20 }) => (
    <img
      src={DeleteIcon}
      alt="Analysis Icon"
      width={width}
      height={height}
    />
  );
  return (
    <>
      <Header />
      <div className='ContentBlock pt-40 pb-24 Main_Block'>
        <div className='edit-catagory'>
          <div className="container-fluid">
            <div className='row'>
              <div className='col-xl-5 col-lg-6 col-sm-12 col-12'>
                <div>
                  <span>Create Edit Category</span>
                  <div className='input-cate'>
                    <input type="text" placeholder="DINNER SAUSAGE COOKED" className="form-control" />
                    <div className='edit-btn' style={{ display: 'flex', flexWrap: 'nowrap', marginLeft: '10px' }}>
                      <button className="cancel-btn"><span>Cancel</span></button>
                      <button className="save-btn">Save</button>
                    </div>
                    {/* <img className="edit-icon" src={Edit} alt="Remove" /> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="row g-3 mt-0">
              <div className="col-12 mb-20">
                <div className="Card Coupons">
                  <div className="Card_Header">
                    <h5>UPC List (My UPCs)</h5>
                    <div className="Card_Header_Right">
                      <button
                        type="button"
                        onClick={openModal}
                        style={{ fontSize: '12px', marginRight: '15px', cursor: 'pointer', background: 'none', border: 'none', color: '#fff', fontWeight: '500' }}
                      >
                        + ADD UPCS
                      </button>
                      <Link to="/" target="_top">
                        <span>View All</span>
                      </Link>
                    </div>
                  </div>
                  <div className="Card_Body">
                    <div className="table-responsive Coupons_Table">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>UPC11</th>
                            <th style={{ textAlign: "left" }}>Product Name</th>
                            <th style={{ textAlign: "left" }}>Item Code</th>
                            <th style={{ textAlign: "left" }}>Category</th>
                            <th style={{ textAlign: "center" }}>Edit</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((item, index) => (
                            <tr key={index}>
                              <td>{item.upc}</td>
                              <td style={{ textAlign: "left" }}>{item.pro_name}</td>
                              <td style={{ textAlign: "left" }}>{item.item_code}</td>
                              <td style={{ textAlign: "left" }}>{item.category}</td>
                              <td style={{ textAlign: "center" }}>
                                <img
                                  className="edit-icon"
                                  src={Edit}
                                  alt="Remove"
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 mb-20">
                <div className='add-btn-wrap'>
                  <h2 className='brand-title'>Comparable Brand UPCs</h2>
                  <button onClick={togglePopup} className='add-btn'>+Add Brand and UPCs</button>
                  {/* Modal */}
                  {isModalVisible && (
                    <div
                      className="modal-overlay"
                      onClick={closeModal}
                    >
                      <div
                        className="modal-content"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="modal-body p-0 pb-20">
                          <div className="input-label mb-10 mt-5">
                            <label htmlFor="brand_name" className="form-label">
                              Brand Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Brand Name"
                              name="brand_name"
                            />
                          </div>
                          <div
                            className="input-label">
                            <label htmlFor="upc" className="form-label">
                              UPCs for Brand
                            </label>
                            <textarea
                              className="form-control"
                              placeholder="UPCs for Brand"
                              name="upc"
                              rows="4"
                            />
                          </div>
                        </div>
                        <div className="edit-cate-btn">
                          <button className="del-btn" onClick={closeModal}><span>Delete</span></button>
                          <div>
                            <button className="cancel-btn" onClick={closeModal}>
                              <span>Cancel</span>
                            </button>
                            <button className="save-btn" onClick={closeModal}>Save</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {isPopupVisible && (
                    <div className="modal-overlay" onClick={togglePopup}>
                      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-body p-0 pb-20">
                          <label className="form-label" style={{ fontSize: '18px', textAlign: 'left', fontWeight: '600' }}>
                            Upload Brand UPCs
                          </label>
                          <div className="input-label">
                            <input type="file" className='upload-input' />
                            <small className='note mt-10' style={{ fontWeight: '500' }}>Note:</small>
                            <small className='note'>You can upload brand items from an Excel file that includes three columns—<span>UPC, productname, and brandname.</span> The columns must appear in this exact order, and the column names must match exactly as shown.</small>
                          </div>
                        </div>
                        <div className="edit-cate-btn">
                          <button className="del-btn" onClick={togglePopup}><span>Delete</span></button>
                          <div>
                            <button className="cancel-btn" onClick={togglePopup}>
                              <span>Cancel</span>
                            </button>
                            <button className="save-btn" onClick={togglePopup}>Save</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="Card Coupons">
                  <div className="Card_Header">
                    <div className='d-flex align-items-center gap-5'>
                      <h5>UPC List - Brand 1</h5>
                      <button className='del-icon' onClick={toggledelPopup} ><DelIcon />Delete</button>
                    </div>
                    {isPopupdel && (
                      <div className="modal-overlay" onClick={toggledelPopup}>
                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                          <div className="modal-body p-0 pb-20">
                            <label className="form-label" style={{ fontSize: '18px', textAlign: 'left', fontWeight: '600' }}>
                              Are you sure you want to delete this record?
                            </label>
                            <span className='alert'>This action cannot be undone.</span>

                          </div>
                          <div className="edit-cate-btn" style={{ justifyContent: 'end' }}>
                            <div>
                              <button className="cancel-btn" onClick={toggledelPopup}>
                                <span>Delete</span>
                              </button>
                              <button className="save-btn" onClick={toggledelPopup}>Cancel</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="Card_Header_Right">
                      <button
                        type="button"
                        onClick={openModal}
                        style={{ fontSize: '12px', marginRight: '15px', cursor: 'pointer', background: 'none', border: 'none', color: '#fff', fontWeight: '500' }}
                      >
                        + ADD UPCS
                      </button>
                      <Link to="/" target="_top">
                        <span>View All</span>
                      </Link>
                    </div>
                  </div>
                  <div className="Card_Body">
                    <div className="table-responsive Coupons_Table">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>UPC11</th>
                            <th style={{ textAlign: "left" }}>Product Name</th>
                            <th style={{ textAlign: "left" }}>Item Code</th>
                            <th style={{ textAlign: "left" }}>Category</th>
                            <th style={{ textAlign: "center" }}>Edit</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((item, index) => (
                            <tr key={index}>
                              <td>
                                {item.upc}
                              </td>
                              <td style={{ textAlign: "left" }}>{item.pro_name}</td>
                              <td style={{ textAlign: "left" }}>{item.item_code}</td>
                              <td style={{ textAlign: "left" }}>{item.category}</td>
                              <td style={{ textAlign: "center" }}>
                                <img
                                  className="edit-icon"
                                  src={Edit}
                                  alt="Remove"
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 mb-20">
                <div className="Card Coupons">
                  <div className="Card_Header">
                    <div className='d-flex align-items-center gap-5'>
                      <h5>UPC List - Brand 2</h5>
                      <button className='del-icon' onClick={toggledelPopup} ><DelIcon />Delete</button>
                    </div>
                    <div className="Card_Header_Right">
                      <button
                        type="button"
                        onClick={openModal}
                        style={{ fontSize: '12px', marginRight: '15px', cursor: 'pointer', background: 'none', border: 'none', color: '#fff', fontWeight: '500' }}
                      >
                        + ADD UPCS
                      </button>
                      <Link to="/" target="_top">
                        <span>View All</span>
                      </Link>
                    </div>
                  </div>
                  <div className="Card_Body">
                    <div className="table-responsive Coupons_Table">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>UPC11</th>
                            <th style={{ textAlign: "left" }}>Product Name</th>
                            <th style={{ textAlign: "left" }}>Item Code</th>
                            <th style={{ textAlign: "left" }}>Category</th>
                            <th style={{ textAlign: "center" }}>Edit</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((item, index) => (
                            <tr key={index}>
                              <td>
                                {item.upc}
                              </td>
                              <td style={{ textAlign: "left" }}>{item.pro_name}</td>
                              <td style={{ textAlign: "left" }}>{item.item_code}</td>
                              <td style={{ textAlign: "left" }}>{item.category}</td>
                              <td style={{ textAlign: "center" }}>
                                <img
                                  className="edit-icon"
                                  src={Edit}
                                  alt="Remove"
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 mb-20">
                <div className="Card Coupons">
                  <div className="Card_Header">
                    <div className='d-flex align-items-center gap-5'>
                      <h5>UPC List - Brand 3</h5>
                      <button className='del-icon' onClick={toggledelPopup} ><DelIcon />Delete</button>
                    </div>
                    <div className="Card_Header_Right">
                      <button
                        type="button"
                        onClick={openModal}
                        style={{ fontSize: '12px', marginRight: '15px', cursor: 'pointer', background: 'none', border: 'none', color: '#fff', fontWeight: '500' }}
                      >
                        + ADD UPCS
                      </button>
                      <Link to="/" target="_top">
                        <span>View All</span>
                      </Link>
                    </div>
                  </div>
                  <div className="Card_Body">
                    <div className="table-responsive Coupons_Table">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>UPC11</th>
                            <th style={{ textAlign: "left" }}>Product Name</th>
                            <th style={{ textAlign: "left" }}>Item Code</th>
                            <th style={{ textAlign: "left" }}>Category</th>
                            <th style={{ textAlign: "center" }}>Edit</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((item, index) => (
                            <tr key={index}>
                              <td>
                                {item.upc}
                              </td>
                              <td style={{ textAlign: "left" }}>{item.pro_name}</td>
                              <td style={{ textAlign: "left" }}>{item.item_code}</td>
                              <td style={{ textAlign: "left" }}>{item.category}</td>
                              <td style={{ textAlign: "center" }}>
                                <img
                                  className="edit-icon"
                                  src={Edit}
                                  alt="Remove"
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterStrict />
    </>
  );
};
export default CreateEditCategory;